// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__1u5G9"};